export enum TypeModel {
  Any = "Any",
  EntitySet = "EntitySet",
  Singleton = "Singleton",
  EntityType = "EntityType",
  ComplexType = "ComplexType",
  EnumType = "EnumType",
  // Bundle Function and Action (bound or unbound; v4 only)
  OperationType = "OperationType",
  // Bundles ActionImport and FunctionImport elements
  OperationImportType = "OperationImportType",
}
